import React from "react";
import { IconContainer, ItemsContainer, MenuItemCard, MenuItemsContainer } from "./style";
import { cardsInfo, hiddenPages } from "@constants/pages";
import { Text } from "nectar-ui";
import { useHistory } from "react-router-dom";
import { AstreaPoweredBy } from "@components/svgs";
import LogoutButton from "./LogoutButton";

type MenuItemsProps = {
  toggleMenu?: () => void;
};

const MenuItems: React.FC<MenuItemsProps> = ({ toggleMenu }) => {
  const history = useHistory();
  const handleNavigateClick = (path: string) => () => {
    if (toggleMenu) toggleMenu();
    history.push(path);
  };

  return (
    <MenuItemsContainer>
      <ItemsContainer>
        {cardsInfo.map((info) => {
          if (hiddenPages.includes(info.link)) return null;

          return (
            <MenuItemCard key={info.link} role="button" onClick={handleNavigateClick(info.link)}>
              {info.icon(16)}
              <Text size="lg" color="gray" noMargin semiBold>
                {info.title}
              </Text>
            </MenuItemCard>
          );
        })}
      </ItemsContainer>
      <LogoutButton />
      <IconContainer>
        <AstreaPoweredBy scale={2.5} />
      </IconContainer>
    </MenuItemsContainer>
  );
};

export default MenuItems;
